import { useIsHomeFeedAPIEnabled } from 'src/store/featureFlags/hooks';

import { useSignedInDashboardContext } from '../../SignedInDashboardContextProvider';
import type { useHomeRecommendations } from '../../hooks/useHomeRecommendations';

export const useRecommendationForCareerFeedAiAssistant = (): Pick<
  ReturnType<typeof useHomeRecommendations>,
  'error' | 'loading' | 'isRefreshLoading' | 'refresh'
> & {
  jobIds: string[];
} => {
  const isFeedEnabled = useIsHomeFeedAPIEnabled();

  const { recommendationsResult, careerFeedResult } =
    useSignedInDashboardContext();

  if (!isFeedEnabled) {
    return {
      ...recommendationsResult,
      jobIds:
        recommendationsResult.rawRecommendedJobs?.globalJobs.map(
          (job) => job.id,
        ) ?? [],
    };
  }

  return {
    // This is a temporary solution to align with the RecsGraphQL to tell GenAI about is the Recs is empty or not
    jobIds:
      careerFeedResult.feedItems?.reduce<string[]>((acc, item) => {
        if (item.type === 'JOB') {
          acc.push(item.id);
        }
        return acc;
      }, []) ?? [],
    ...careerFeedResult,
  };
};
